import type { CSSProperties } from 'react';

import classnames from 'classnames';

import { computeFont } from '../utils/fonts';

import * as styles from './UpdatePassword.css';
import type { UpdatePasswordElementProps } from './UpdatePassword.types';

export function UpdatePasswordElement(props: UpdatePasswordElementProps) {
  const { element, children, attributes, className, isSubmitting } = props;

  const {
    height,
    width,
    mobile_hide,
    desktop_hide,
    customAttributes,
    borderWidth,
    borderRadius,
    borderColor,
    borderStyle,
    padding,
    backgroundColor,
    gap,
    inputBorderWidth,
    inputBorderRadius,
    inputBorderColor,
    inputBackgroundColor,
    inputBorderStyle,
    inputTextColor,
    inputPlaceholderColor,
    passwordInputPlaceholder,
    buttonBorderWidth,
    buttonBorderRadius,
    buttonBorderColor,
    buttonBorderStyle,
    buttonBackgroundColor,
    buttonTextColor,
    buttonFontFamily,
    buttonText,
    buttonSubmittingText,
    textColor,
    fontFamily,
  } = element.attrs || {};

  return (
    <div
      {...customAttributes}
      className={classnames(
        className,
        {
          'mobile:hidden': mobile_hide,
          'desktop:hidden': desktop_hide,
          'pointer-events-none': isSubmitting,
        },
        styles.updatePasswordElement,
        customAttributes?.className,
        'flex flex-col gap-2',
      )}
      style={
        {
          width: '100%',
          maxWidth: width,
          gap: gap,
          color: textColor,
          borderColor: borderColor,
          borderWidth: borderWidth,
          borderRadius: borderRadius,
          borderStyle: borderStyle,
          padding: padding,
          backgroundColor: backgroundColor,
          boxSizing: 'border-box',
          overflow: 'hidden',
          fontFamily: computeFont(fontFamily) || 'inherit',
          '--input-background-color': inputBackgroundColor,
          '--button-font-family': computeFont(buttonFontFamily),
        } as CSSProperties
      }
      {...attributes}
    >
      <div className="flex flex-col gap-y-1 w-full text-left">
        <label htmlFor="password">Password</label>
        <input
          type="password"
          name="password"
          required
          className={classnames(styles.input, 'w-full pr-4 cursor-text pl-4')}
          style={
            {
              borderColor: inputBorderColor,
              borderWidth: inputBorderWidth,
              borderRadius: inputBorderRadius,
              borderStyle: inputBorderStyle,
              height: height || '50px',
              color: inputTextColor,
              '--placeholder-color': inputPlaceholderColor,
            } as CSSProperties
          }
          placeholder={passwordInputPlaceholder}
        />
      </div>
      <div className="flex flex-col gap-y-1 w-full text-left">
        <label htmlFor="password_confirmation">Confirm password</label>
        <input
          type="password"
          name="password_confirmation"
          required
          className={classnames(styles.input, 'w-full pr-4 cursor-text pl-4')}
          style={
            {
              borderColor: inputBorderColor,
              borderWidth: inputBorderWidth,
              borderRadius: inputBorderRadius,
              borderStyle: inputBorderStyle,
              height: height || '50px',
              color: inputTextColor,
              '--placeholder-color': inputPlaceholderColor,
            } as CSSProperties
          }
          placeholder={passwordInputPlaceholder}
        />
      </div>
      <input
        type="submit"
        disabled={isSubmitting}
        className={classnames(styles.button, 'disabled:opacity-50 disabled:pointer-events-none cursor-pointer')}
        style={
          {
            borderRadius: buttonBorderRadius,
            borderColor: buttonBorderColor,
            borderWidth: buttonBorderWidth,
            borderStyle: buttonBorderStyle,
            backgroundColor: buttonBackgroundColor,
            color: buttonTextColor,
            boxSizing: 'border-box',
            height: height || '50px',
            padding: '0 16px 0 16px',
          } as CSSProperties
        }
        value={isSubmitting ? buttonSubmittingText : buttonText}
      />
      {children}
    </div>
  );
}
